var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgServices = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.125 6.5a5.626 5.626 0 0 1-7.886 5.156l-4.067 4.705-.03.033a2.5 2.5 0 0 1-3.537-3.536q.016-.016.034-.03L6.344 8.76a5.63 5.63 0 0 1 6.526-7.717.625.625 0 0 1 .307 1.03L10.25 5.25l.442 2.058 2.058.442 3.176-2.931a.625.625 0 0 1 1.03.307q.168.676.169 1.374"
})));
export { SvgServices as ReactComponent };
export default __webpack_public_path__ + "static/media/services.b071ada5.svg";